export const GRID_SIZE_PX = 40;
export const CARD_PADDING = GRID_SIZE_PX / 5;
export const CARD_SIZE = GRID_SIZE_PX - CARD_PADDING * 2;
